define(function (require, exports, module) {
    'use strict';

    var UploadFail = require('./UploadFail');

    /**
     * @constructor
     * @extends {UploadFail}
     * @param {Error} stack
     * @param {string} source
     * @param {number} size – in bytes.
     */
    function FileWithoutHashFail(stack, source) {
        UploadFail.apply(this, arguments);
    }

    FileWithoutHashFail.prototype = Object.assign(Object.create(UploadFail.prototype), {
        constructor: FileWithoutHashFail,
        className: 'FileWithoutHashFail',
        radarName: 'fail_{SOURCE}_file-without-hash',
        message: 'Размер файла меньше 21 байт.',
    });

    module.exports = FileWithoutHashFail;
});
